import React from 'react';
import {Box, Card, CardActionArea, Paper, Skeleton, Stack, Typography} from '@mui/material';

import {Colors} from '@constants/colors.constants';
import {DownRed, UpGreen} from '@icons/index';

interface StatisticsCardProps {
  description: string;
  handleClick?: () => void;
  loading?: boolean;
  progress?: number;
  selected?: boolean;
  title: string;
  unit: string;
  value: number | string;
}

const StatisticsCard = (props: StatisticsCardProps) => {
  const {
    description,
    handleClick,
    loading,
    progress,
    selected,
    title,
    unit,
    value,
  } = props;

  let progressColor = Colors.warning;
  if (progress && progress > 0) progressColor = Colors.success;
  if (progress && progress < 0) progressColor = Colors.error;

  return (
    <Card
      variant="statistic"
      aria-selected={selected}
      component={!!handleClick && !selected ? CardActionArea : Paper}
      onClick={!!handleClick && !selected ? handleClick : undefined}>
      <Stack>
        {!!progress && !loading && (
          <Box
            position="absolute" top="18px" right="20px"
            bgcolor={Colors.background} px="8px" py="2px" borderRadius="4px">
            <Stack direction="row" alignItems="center" spacing={1}>
              {progress > 0 ? <UpGreen/> : <DownRed/>}
              <Typography fontSize={14} fontWeight="700" color={progressColor}>{progress}%</Typography>
            </Stack>
          </Box>
        )}
        <Typography fontSize={14} fontWeight="400" mb="18px">{title}</Typography>
        <Stack direction="row" alignItems="center" spacing={1} mb="6px">
          {loading ? (
            <Skeleton variant="text" height="45px" width="30px"/>
          ) : (
            <Typography fontSize={36} fontWeight="700">{value}</Typography>
          )}
          <Typography fontSize={14} fontWeight="400" color={Colors.textWithOpacity} pt="4px">
            {unit}
          </Typography>
        </Stack>
        <Typography fontSize={14} fontWeight="400" color={Colors.textWithOpacity}>{description}</Typography>
      </Stack>
    </Card>
  );
};

export default StatisticsCard;
